export const sendMessageToWebview = function (message) {
  try {
    const bridge = getJSBridge();
    if (bridge && bridge.postMessage) {
      bridge.postMessage(message);
    }
  } catch (err) {
    console.error("Webview JS Bridge", err);
  }
};

function getJSBridge() {
  if (typeof window !== "undefined") {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.StaffBridge) {
      return window.webkit.messageHandlers.StaffBridge;
    }
  }

  if (typeof StaffBridge !== "undefined") {
    // eslint-disable-next-line no-undef
    return StaffBridge;
  }
}
